// Mock data for Spanglish Landing Page - ENGLISH VERSION

export const heroData = {
  title: "Hola Spanglish",
  subtitle: "Learn Spanish Naturally and Effectively",
  description: "Personalized classes with native teachers. From beginners to advanced. Start your Spanish journey today.",
  ctaPrimary: "Free Class",
  ctaSecondary: "View Prices",
  image: "https://images.unsplash.com/photo-1673515336170-3bf951ddb5a8"
};

export const methodData = {
  title: "Our Method",
  subtitle: "Learn Spanish in a practical and conversational way",
  features: [
    {
      id: 1,
      title: "Total Immersion",
      description: "Immerse yourself in the language from day one with real conversations and practical contexts.",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Personalized Classes",
      description: "Each lesson adapts to your level, goals and individual learning pace.",
      icon: "User"
    },
    {
      id: 3,
      title: "Native Teachers",
      description: "Learn with certified instructors from Spanish-speaking countries with proven experience.",
      icon: "GraduationCap"
    },
    {
      id: 4,
      title: "Total Flexibility",
      description: "Choose your schedule and study from anywhere in the world with our online classes.",
      icon: "Clock"
    }
  ],
  image: "https://images.unsplash.com/photo-1757194455329-541f39364057"
};

export const teachersData = {
  title: "Our Teachers",
  subtitle: "Native experts committed to your success",
  teachers: [
    {
      id: 1,
      name: "Johana Mariel Ramirez",
      specialty: "Founder of Spanglish",
      country: "Argentina",
      experience: "8 years of experience",
      description: "Creator of Spanglish, passionate about teaching Spanish naturally and effectively. Specialized in conversational classes.",
      image: "https://customer-assets.emergentagent.com/job_spanglish-hub/artifacts/q1x100ql_WhatsApp%20Image%202025-11-26%20at%2010.05.12%20PM.jpeg",
      rating: 5.0
    },
    {
      id: 2,
      name: "Lucía Pinciaroli",
      specialty: "Spanish for All Levels",
      country: "Argentina",
      experience: "6 years of experience",
      description: "Dedicated teacher focused on grammar and conversation. Helps students at all levels achieve their goals.",
      image: "https://customer-assets.emergentagent.com/job_spanglish-hub/artifacts/3z9wva4j_WhatsApp%20Image%202025-11-26%20at%2011.27.41%20PM.jpeg",
      rating: 4.9
    }
  ]
};

export const pricingData = {
  title: "Plans & Pricing",
  subtitle: "Choose the plan that best fits your needs",
  plans: [
    {
      id: 1,
      name: "Basic",
      price: "175",
      currency: "USD",
      period: "month",
      description: "Perfect to start your Spanish adventure",
      features: [
        "4 classes per month (1 per week)",
        "45-minute classes",
        "Educational materials included",
        "Online platform access"
      ],
      popular: false,
      buttonText: "Start Now"
    },
    {
      id: 2,
      name: "Professional",
      price: "280",
      currency: "USD",
      period: "month",
      description: "The most popular plan for accelerated learning",
      features: [
        "8 classes per month (2 per week)",
        "1 x 60-min class (grammar & vocabulary)",
        "1 x 45-min class (conversational)",
        "Educational materials included",
        "Online platform access",
        "Personalized homework",
        "Progress exams"
      ],
      popular: true,
      buttonText: "Start Now"
    },
    {
      id: 3,
      name: "Intensive",
      price: "410",
      currency: "USD",
      period: "month",
      description: "Maximum immersion for fast results",
      features: [
        "12 classes per month (3 per week)",
        "2 x 60-min classes (grammar & vocabulary)",
        "1 x 45-min class (conversational)",
        "Premium educational materials",
        "Online platform access",
        "Personalized homework",
        "Progress exams",
        "1 group session per month (Talkative)",
        "Email support from your tutor"
      ],
      popular: false,
      buttonText: "Start Now"
    }
  ]
};

export const faqData = {
  title: "Frequently Asked Questions",
  subtitle: "Everything you need to know before starting your Spanish journey",
  questions: [
    {
      id: 1,
      question: "How do the programs work?",
      answer: "Each program is a package of private 1-on-1 sessions with a fixed validity period. You choose how to use them — weekly, intensively, or at your own pace — within that window. You also get a personalized learning plan built around your goals."
    },
    {
      id: 2,
      question: "Do I need prior Spanish knowledge?",
      answer: "Not at all. The STARTER program is perfect for absolute beginners. MOMENTUM and IMMERSION suit learners who already know the basics. FLUENCY JOURNEY and ELITE are ideal for committed students who want long-term transformation."
    },
    {
      id: 3,
      question: "How are sessions delivered?",
      answer: "All sessions are 100% online via live video with Johana. You only need a stable internet connection and a device with a camera. After each session you'll receive personalized notes and homework if you want them."
    },
    {
      id: 4,
      question: "Can I reschedule a session?",
      answer: "Yes. Sessions can be rescheduled with at least 24 hours' notice at no cost. Late cancellations (less than 24h) may be counted as a completed session."
    },
    {
      id: 5,
      question: "What happens to unused sessions after the program expires?",
      answer: "Sessions must be used within the validity period of your program. Unused sessions do not roll over after the program ends, so we recommend planning your pace at the start. Need more time? Just upgrade to a longer program."
    },
    {
      id: 6,
      question: "Do you offer DELE or school exam preparation?",
      answer: "Yes. We offer a DELE Prep Add-On (mock orals, writing corrections, exam strategies) and a School Support Add-On (homework, tests, grammar reviews) on top of any program. For urgent exams there's also the Intensive Exam Sprint."
    },
    {
      id: 7,
      question: "How do I pay?",
      answer: "All programs are paid securely through PayPal. Just click the 'Start Now' button on any plan and you'll be redirected to paypal.me/HolaSpanglish to complete your purchase."
    },
    {
      id: 8,
      question: "Is there a returning student discount?",
      answer: "Yes — students who start with the STARTER program and choose to continue with a longer program receive a special returning student discount. Get in touch and we'll set it up for you."
    }
  ]
};

export const contactData = {
  title: "Ready to Start?",
  subtitle: "Send us a message and we'll help you choose the right program",
  formTitle: "Get in Touch",
  formSubtitle: "Fill out the form and we'll reply within 24 hours. We'll help you pick the program that fits your goals.",
  email: "spanglish.clasesonline@gmail.com",
  phone: "+54 3447 542166"
};

export const footerData = {
  companyName: "Hola Spanglish",
  tagline: "Your bridge to Spanish",
  description: "Learn Spanish with the best native teachers. Personalized online classes for all levels.",
  email: "spanglish.clasesonline@gmail.com",
  phone: "+54 3447 542166",
  links: {
    company: [
      { name: "About", href: "#about" },
      { name: "Programs", href: "#programs" },
      { name: "How It Works", href: "#how-it-works" }
    ],
    support: [
      { name: "FAQ", href: "#faq" },
      { name: "Contact", href: "#contact" },
      { name: "Guidelines", href: "#guidelines" }
    ],
    legal: [
      { name: "Terms & Conditions", href: "#terms" },
      { name: "Privacy Policy", href: "#privacy" },
      { name: "Cancellation Policy", href: "#cancellation" }
    ]
  },
  social: {
    instagram: "https://www.instagram.com/holaspanglish?igsh=cWN4eTIxM3RxYnJp&utm_source=qr",
    tiktok: "https://www.tiktok.com/@hola.spanglish",
    threads: "https://www.threads.com/@holaspanglish?igshid=NTc4MTIwNjQ2YQ=="
  },
  copyright: `© ${new Date().getFullYear()} Hola Spanglish. All rights reserved.`
};
